import { styled } from "@mui/system";

export const CommentsBlockContainer = styled("div")({
    width: "100%",
});
